export default {
  name: 'StudentCard',
  props: ['student']
};



// WEBPACK FOOTER //
// ./src/components/service-log/form/student-card/student-card.js